function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded = ["breakpoints", "children", "className", "empty", "error", "footer", "hover", "id", "loading", "look"],
  _excluded2 = ["breakpoints", "look", "maxHeight", "scrollX", "scrollY"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import { TableLooks } from "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import { BaseTable } from "../base-table/base-table.js";
import { TableWrapper } from "./table-wrapper.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledTable = function UnstyledTable(props) {
  var _classnames;
  var breakpoints = props.breakpoints,
    children = props.children,
    className = props.className,
    empty = props.empty,
    error = props.error,
    footer = props.footer,
    hover = props.hover,
    id = props.id,
    loading = props.loading,
    look = props.look,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseTable, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-table__standard-table': true,
      'bf-table__standard-table--breakpoints': !!breakpoints,
      'bf-table__standard-table--empty': empty,
      'bf-table__standard-table--error': error,
      'bf-table__standard-table--footer': footer,
      'bf-table__standard-table--hover': hover,
      'bf-table__standard-table--loading': loading
    }, _defineProperty(_classnames, "bf-table__standard-table--".concat(look), look), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    id: id
  }), children);
};
var blockTable = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n"])));
var tableTable = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: table;\n"])));
var getTableBreakpoints = function getTableBreakpoints(breakpoints) {
  return breakpoints.map(function (breakpoint, index) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "])), breakpoint, index % 2 === 0 ? tableTable : blockTable);
  });
};
var StyledTable = styled(UnstyledTable)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  background-color: ", ";\n  border-collapse: collapse;\n  border-spacing: 0;\n  box-sizing: border-box;\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  position: relative;\n  white-space: normal;\n  width: 100%;\n\n  > .bf-table__standard-tbody {\n    > .bf-table__standard-tr:hover {\n      background-color: ", ";\n    }\n  }\n"])), blockTable, function (_ref) {
  var breakpoints = _ref.breakpoints;
  return getTableBreakpoints(breakpoints || []);
}, function (_ref2) {
  var look = _ref2.look,
    theme = _ref2.theme;
  return theme.table[look].backgroundColor;
}, function (_ref3) {
  var look = _ref3.look,
    theme = _ref3.theme;
  return theme.table[look].textColor;
}, fontFamilyBook, function (_ref4) {
  var empty = _ref4.empty,
    error = _ref4.error,
    hover = _ref4.hover,
    loading = _ref4.loading,
    look = _ref4.look,
    theme = _ref4.theme;
  return !empty && !error && !loading && hover ? theme.table[look].trHoverBackgroundColor : 'transparent';
});
/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/table
 * @param props TableProps
 * @returns FunctionComponent<TableProps>
 */
var Table = function Table(props) {
  var breakpoints = props.breakpoints,
    _props$look = props.look,
    look = _props$look === void 0 ? TableLooks.Default : _props$look,
    maxHeight = props.maxHeight,
    _props$scrollX = props.scrollX,
    scrollX = _props$scrollX === void 0 ? true : _props$scrollX,
    scrollY = props.scrollY,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  var table = /*#__PURE__*/React.createElement(StyledTable, _extends({}, otherProps, {
    breakpoints: breakpoints,
    look: look
  }));
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, scrollX || scrollY ? /*#__PURE__*/React.createElement(TableWrapper, {
    breakpoints: breakpoints,
    scrollX: scrollX,
    scrollY: scrollY,
    style: {
      maxHeight: scrollY ? maxHeight || '500px' : undefined
    }
  }, table) : table);
};
export { Table };